import { render, staticRenderFns } from "./ControlProductSelection.vue?vue&type=template&id=de8ca5d6&"
import script from "./ControlProductSelection.vue?vue&type=script&lang=ts&"
export * from "./ControlProductSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports